import React from 'react'
import { NumberColumn, Column, WidgetCell, NumberField, ComboBox } from '@sencha/ext-modern'

import { genWidgetcellChangeHandler } from './utilities'

const render = ({ _int: text, dataIndex, format = '0,000', handleEdit, edit, align = 'right', ...rest }) => {
	return edit
		? <Column {...{ dataIndex, text, align, ...rest }}>
			<WidgetCell bodyStyle={{ padding: "0px 12px" }}>
				{edit.options || edit.bind.options
					? <ComboBox
						clearable={false}
						// forceSelection={true}
						editable={false}
						anyMatch={true}
						textAlign='right'
						itemCls='t-grideditintlistitem'
						onChange={genWidgetcellChangeHandler(handleEdit, dataIndex, 'number')}
						{...edit} />
					: <NumberField {...{ decimals: 0, thousandsSeperator: true, textAlign: align }}
						clearable={false}
						onChange={genWidgetcellChangeHandler(handleEdit, dataIndex, 'number')}
						{...edit}
					/>
				}
			</WidgetCell>
		</Column>
		: <NumberColumn {...{ dataIndex, text, align, format, ...rest }} />
}

export default render